// FR/EN switch — a compact segmented control with a globe glyph and a sliding
// gold thumb (moved out of AdminLayout: on phones it now lives in « More »).
// Accessible (radiogroup), 200 ms motion, reduced-motion safe.
import { cn } from '@/lib/utils';
import { useT } from '@/lib/i18n';

export function LangSwitcher({ className }: { className?: string }) {
  const { lang, setLang } = useT();
  return (
    <div
      role="radiogroup"
      aria-label="Langue / Language"
      className={cn('relative inline-flex items-center rounded-full p-0.5 select-none', className)}
      style={{ background: 'rgba(201,162,74,0.10)', border: '1px solid rgba(201,162,74,0.28)' }}
    >
      <span className="grid place-items-center w-7 h-7 shrink-0" style={{ color: 'var(--color-adm-gold-deep)' }} aria-hidden>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" className="w-[15px] h-[15px]">
          <circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
        </svg>
      </span>
      <span
        aria-hidden
        className="absolute top-0.5 bottom-0.5 rounded-full transition-transform duration-200 ease-out motion-reduce:transition-none"
        style={{
          width: 38, left: 34, background: '#C9A24A',
          boxShadow: '0 1px 3px rgba(139,111,38,0.45)',
          transform: lang === 'en' ? 'translateX(38px)' : 'translateX(0)',
        }}
      />
      {(['fr', 'en'] as const).map((l) => (
        <button
          key={l}
          type="button"
          role="radio"
          aria-checked={lang === l}
          onClick={() => setLang(l)}
          className={cn(
            'relative z-10 w-[38px] h-8 rounded-full text-[11px] font-bold uppercase tracking-[0.06em] transition-colors',
            lang === l ? 'text-white' : 'text-[#7A6A45] hover:text-[#3a3320] dark:text-adm-muted dark:hover:text-adm-ink',
          )}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
